/**
 * Created by Jie Gao on 7/30/2019.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {TimelineLite, TweenLite} from "gsap";
import {DragonTribeGameConfig} from "../../DragonTribeGameConfig";
import {DragonTribeSoundConfig} from "../../DragonTribeSoundConfig";
import {DragonTribeParsedGameData} from "../../server/data/DragonTribeParsedGameData";
import {DTReelSymbol} from "../../symbols/DTReelSymbol";
import {DTReelController} from "../DTReelController";

export class ReelExpansionController extends ReelStopPresentationController {

    private readonly _symbolScaleDuration:number = 0.5;

    private _shouldExpand:boolean = false;
    private _gameAreaSize:number[];
    private _mysterySymbolOnReel:boolean[];
    private _mysterySymbolPositions:number[];
    private _mysterySymbolSize:number[];
    private _mysterySymbolRevealed:string;
    private _mode:GameMode;
    private _reelStopStates:boolean[];
    private _xWaysSymbolMayGiveWin:boolean;
    private _xWaysSymbolMayGiveWinPositions:boolean[][];

    constructor(index:number) {
        super(index, "ReelExpansion");
    }

    protected parseFeatureGameData(data:DragonTribeParsedGameData):void {
        this._mode = data.mode;
        this._gameAreaSize = data.gameAreaSize.concat();
        this._mysterySymbolOnReel = data.mysterySymbolOnReel.concat();
        this._mysterySymbolPositions = data.mysterySymbolPositions.concat();
        this._mysterySymbolSize = data.mysterySymbolSize.concat();
        this._mysterySymbolRevealed = data.mysterySymbolRevealed;
        this._xWaysSymbolMayGiveWin = data.xWaysSymbolMayGiveWin;
        this._xWaysSymbolMayGiveWinPositions = data.xWaysSymbolMayGiveWinPositions;
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, SpinEvent.START, (event:GamepadEvent) => this.onSpinStart());
    }

    private onSpinStart():void {
        this._reelStopStates = ArrayHelper.initArrayWithValues(6, index => false);
    }

    protected dispatchCompleteEvent(reelId:number):void {
        this._reelStopStates[reelId] = true;
        super.dispatchCompleteEvent(reelId);
    }

    private isLastReel(reelId:number):boolean {
        for(let i:number = 0; i < 6; i++) {
            if(i === reelId) {
                continue;
            }

            // there is not stopped reel
            if(!this._reelStopStates[i]) {
                return false;
            }
        }
        return true;
    }

    public onReelStopSymbolAttention(data:IReelStoppedData):void {
        if(!this._mysterySymbolOnReel[data.reelId]) {
            return;
        }

        const symbol:StateReelSymbol | null = Reels.getSymbol(data.reelId, this._mysterySymbolPositions[data.reelId]);
        if(symbol == null) {
            debugger;
            throw new Error(`ReelExpansionController.onReelBounce(): Cannot find symbol at reelId = ${data.reelId}, symbolId = ${this._mysterySymbolPositions[data.reelId]}.`);
        }
        symbol.parent.addChild(symbol);

        if(data.symbols![0].symName === "M") {
            SlotGame.sound.playEffect(DragonTribeSoundConfig.M_LANDING);
            symbol.changeState({state : DragonTribeGameConfig.instance.SYMBOL_STATES.attention});
        }
        this._shouldExpand = true;
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(!this._shouldExpand || !this.isLastReel(data.reelId)) {
            this.dispatchCompleteEvent(data.reelId);
            return;
        }
        const timeline:TimelineLite = new TimelineLite({paused : true});
        timeline.add(() => {
            if(this._xWaysSymbolMayGiveWin) {
                SlotGame.sound.playEffect(DragonTribeSoundConfig.M_WIN_HIGHLIGHT);
                this._xWaysSymbolMayGiveWinPositions.forEach((pos:boolean[], i:number) => {
                    pos.forEach((mayWin:boolean, j:number) => {
                        if(mayWin) {
                            (<DTReelSymbol>Reels.getSymbol(i, j))!.playHighlightAnimation();
                        }
                    });
                });
            }
        }, 0);
        this._mysterySymbolOnReel.forEach((onReel:boolean, reelId:number) => {
            if(onReel) {
                timeline.add(this.getMysterySymbolOnReelAnimation(reelId), 0);
            }
        });
        timeline.add(() => this.dispatchCompleteEvent(data.reelId));
        timeline.play();
    }

    private getMysterySymbolOnReelAnimation(reelId:number):TimelineLite {
        const animTimeScaleDuration:number = this._xWaysSymbolMayGiveWin ? 1 : 1.75;
        const reelTimeline:TimelineLite = new TimelineLite();
        const mysterySymbol:StateReelSymbol | null = Reels.getSymbol(reelId, this._mysterySymbolPositions[reelId]);
        if(!mysterySymbol) {
            debugger;
            throw new Error(`ReelExpansionController.onReelSpinStopped(): Cannot find symbol at reelId = ${reelId}, symbolId = ${this._mysterySymbolPositions[reelId]}.`);
        }
        reelTimeline.timeScale(animTimeScaleDuration);
        reelTimeline.add(mysterySymbol.changeState({
            state : DragonTribeGameConfig.instance.SYMBOL_STATES.expand,
            frames : [0, 17],
            replay : true,
            fadeInDuration : 0.5
        }));
        reelTimeline.add([
            () => {SlotGame.sound.playEffect(DragonTribeSoundConfig.M_EXPAND)},
            this.getSymbolExpandingAnimation(reelId)
        ]);
        reelTimeline.add(() => this.replaceSymbols(reelId));
        reelTimeline.add([
            mysterySymbol.changeState({
                state : DragonTribeGameConfig.instance.SYMBOL_STATES.expand,
                frames : [18, -1],
                replay : true,
                fadeInDuration : 0.5
            })
        ]);
        reelTimeline.add(() => (<DTReelController>Reels.getReel(reelId)).removeReplacedSymbol(mysterySymbol));

        return reelTimeline;
    }

    private getSymbolExpandingAnimation(reelId:number):any[] {
        const scaleDuration:number = this._symbolScaleDuration;
        const reelSize:number = this._gameAreaSize[reelId];
        const mysterySymbolSize:number = this._mysterySymbolSize[reelId];
        const afterExpandReelSize:number = reelSize + mysterySymbolSize - 1;
        const symbolHeight:number = DTReelController.SYM_SIZE[afterExpandReelSize].height;
        const symbolBottomPadding:number = DTReelController.SYM_SIZE[afterExpandReelSize].padding;
        const symbolStep:number = symbolHeight + symbolBottomPadding;
        const mysterySymbolPosition:number = this._mysterySymbolPositions[reelId];

        const mysterySymbolHeight:number = symbolHeight * mysterySymbolSize + symbolBottomPadding * (mysterySymbolSize - 1);
        const symbolScaleY:number = mysterySymbolHeight / DTReelController.SYM_SIZE[4].height;
        const expandAnimations:any[] = [];
        // Expand E symbols and shrank other symbols
        if(mysterySymbolSize > 1) {
            for(let i:number = 2; i < 6; i++) {
                const symbol:DTReelSymbol = <DTReelSymbol>Reels.getSymbol(reelId, i);
                if(i === mysterySymbolPosition) { // don't use the name checking here so it doesn't get wrong if  the outcome setting gives 2 E at the same time.
                    expandAnimations.push(
                        TweenLite.to(symbol.scale, scaleDuration, {y : symbolScaleY}),
                        TweenLite.to(symbol, scaleDuration, {y : (i - 5) * symbolStep - mysterySymbolHeight / 2})
                    );
                } else {
                    expandAnimations.push(
                        TweenLite.to(symbol, scaleDuration, {
                            symHeight : symbolHeight,
                            bottomPadding : symbolBottomPadding
                        })
                    );
                    if(i < mysterySymbolPosition) {
                        // symbol position above the mystery symbol, if W the visible is the very bottom one
                        expandAnimations.push(
                            TweenLite.to(symbol, scaleDuration, {y : (i - (afterExpandReelSize - 4) - 5) * symbolStep - symbolHeight / 2})
                        );
                    } else {
                        // symbol position below the mystery symbol
                        const realSymId:number = (<DTReelController>Reels.getReel(reelId)).getRealSymId(symbol);
                        expandAnimations.push(
                            TweenLite.to(symbol, scaleDuration, {y : (realSymId - 5) * symbolStep - symbolHeight / 2})
                        );
                    }
                }
            }
        }
        return expandAnimations;
    }

    private replaceSymbols(reelId:number):void {
        const mysterySymbolSize:number = this._mysterySymbolSize[reelId];
        (<DTReelController>Reels.getReel(reelId)).addExpandingSymbols(this._mysterySymbolRevealed, mysterySymbolSize, this._mysterySymbolPositions[reelId], this._gameAreaSize[reelId]);
    }

    protected resetFeature():void {
        this._shouldExpand = false;
    }
}